<!--
	SafeIntersections dashboard: Identify and Prioritize donut breakdowns (by intersection count)
	plus the Interventions teaser.
-->
<script lang="ts">
	import { ESafeIntersectionsModule, type ISafeIntersectionsSummaryData } from '../interfaces';
	import { mapPriorityDescription } from '../columns';
	import SummaryCard, { tally } from '../../SummaryCard.svelte';
	import SummaryCardGroup from '../../SummaryCardGroup.svelte';
	import { identifyColours, prioritizeColours } from '#lib/vizPalette.js';

	interface Props {
		summaryData: ISafeIntersectionsSummaryData;
	}
	const { summaryData }: Props = $props();

	function statsOf(slices: { key: string; value: number }[], key: string) {
		const total = slices.reduce((a, s) => a + s.value, 0);
		const value = slices.find((s) => s.key === key)!.value;
		return [
			{
				value: value.toLocaleString('en-US'),
				of: `of ${total.toLocaleString('en-US')} intersections`
			}
		];
	}

	const identify = $derived(
		tally(
			summaryData[ESafeIntersectionsModule.Identify],
			(r) => r.intersection_class as string,
			identifyColours
		)
	);
	const prioritize = $derived(
		tally(
			summaryData[ESafeIntersectionsModule.Prioritize],
			(r) => mapPriorityDescription[r.intersection_priority as string],
			prioritizeColours
		)
	);
</script>

<SummaryCardGroup>
	<SummaryCard
		title="Identify"
		blurb="Intersections categorized according to crash risk."
		statHeading="Class 1 intersections"
		stats={statsOf(identify, 'Class 1')}
		donutHeading="Intersection class breakdown"
		donut={identify} />
	<SummaryCard
		title="Prioritize"
		blurb="Intersection risk prioritized."
		statHeading="Priority 1 intersections"
		stats={statsOf(prioritize, 'Priority 1')}
		donutHeading="Intersection priority breakdown"
		donut={prioritize} />
	<SummaryCard
		title="Interventions"
		blurb="Reduce the likelihood of crashes with appropriate interventions." />
</SummaryCardGroup>
